<template>
  <div class="navbar_container">
    <div id="nav_bar_left" class="flex flex-row gap-2">
      <a :href="basePath + '/home'" rel="noopener noreferrer">
        <div class="superagi_logo" v-on:click="moveToManageBilling">
          <img width="45" alt="superagi_icon" :src="imagePath.superAgiIcon" class="w-10 h-10 mt-1" />
        </div>
      </a>
      <div id="nav_bar_left" class="flex items-center ml-2 text_color text-[17px]">Billing</div>
    </div>
    <div class="flex flex-row items-center relative">
      <div
        id="navbar_dropdown_open_section"
        class="ant-dropdown-link mr-4"
        ref="dropdownToggle"
        @click.prevent="isDropdownOpen = !isDropdownOpen"
        style="display: flex; justify-content: flex-end; align-items: center; cursor: pointer; text-decoration: none"
      >
        <ProfileIcon :data="{ name: userName }" :size="40" :font="16" />
      </div>

      <transition name="slide-fade">
        <div id="navbar_dropdown" ref="navbarDropdown" class="navbar_dropdown_container" v-if="isDropdownOpen">
          <div v-if="workspaces.length > 0" class="overflow-y-scroll border_bottom" style="max-height: 500px">
            <div class="navbar_heading font-semibold text-[15px]">Workspaces</div>
            <div v-for="workspace in workspaces" :key="workspace.ID">
              <div v-on:click="switchWorkspace(workspace)" class="navbar_dropdown_subheadings cursor-pointer" :class="[workspace.IsCurrent ? 'workspace_current' : '']">{{ workspace.Name }}</div>
            </div>
          </div>

          <div class="navbar_dropdown_headings !flex flex-row items-center justify-between cursor-pointer" v-on:click="logout">
            <span>Logout</span>
            <img :src="imagePath.logoutIcon" class="dropdown_app_images" alt="logout_icon" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from 'vue';
import imagePath from '@/javascript/imagePath';
import ProfileIcon from '@/components/custom/ProfileIcon.vue';
import { emit } from '@/javascript/eventBus';
import { useIntercom } from '@/composables/useIntercom';
import { initializeIntercom } from '@/javascript/pluginUtils';
import ThemeImage from '@/components/custom/ThemeImage.vue';
import { imageNames } from '@/javascript/imageConstants';

const isDropdownOpen = ref(false);
import DashboardService from '@/services/DashboardService';
const userName = ref('');
const workspaces = ref([]);
const navbarDropdown = ref(null);
const dropdownToggle = ref(null);
const basePath = DashboardService.getBaseSalesPath();
const intercom = useIntercom();

const moveToManageBilling = () => {
  emit('page_changed', {
    main_page: 'manage_billing',
  });
};

const props = defineProps({
  workspaceId: { type: [String, Number], required: false, default: null },
});

const logout = async () => {
  try {
    const response = await DashboardService.logout();
    if (response?.success) {
      let url = 'https://sales.superagi.com/';
      if (process.env.NODE_ENV === 'staging') {
        url = 'https://sales-staging.superagi.com/';
      } else if (process.env.NODE_ENV === 'development') {
        url = 'http://localhost:3000/';
      }
      localStorage.removeItem('billing_workspace_id');
      window.open(url, '_self', 'noopener,noreferrer');
    }
  } catch (error) {
    console.error('Error during logout:', error);
  }
};

const fetchUserData = async () => {
  const workspaceId = localStorage.getItem('billing_workspace_id') || '';
  const response = await DashboardService.checkUser(workspaceId);
  initializeIntercom(response.user, intercom);
  if (response?.success && response.user) {
    const { first_name, last_name } = response.user;
    workspaces.value = response.user.Workspaces;
    userName.value = `${first_name || ''} ${last_name || ''}`.trim();
  }
};

const switchWorkspace = async (workspace) => {
  if (workspace.IsCurrent) {
    isDropdownOpen.value = false;
    return;
  }

  const response = await DashboardService.switchWorkspace(workspace.ID);
  if (response?.success) {
    localStorage.setItem('billing_workspace_id', String(workspace.ID));
    localStorage.setItem('mainPage', 'manage_billing');
    emit('page_changed', {
      main_page: 'manage_billing',
    });
    window.location.reload();
  }

  isDropdownOpen.value = false;
};

const openKnowYourBilling = () => {
  window.open('/know_your_billing', '_blank');
};

const handleClickOutside = (event) => {
  if (navbarDropdown.value && !navbarDropdown.value?.contains(event.target) && dropdownToggle.value && !dropdownToggle.value?.contains(event.target)) {
    isDropdownOpen.value = false;
  }
};

onMounted(async () => {
  document.addEventListener('click', handleClickOutside);
  setTimeout(async () => {
    await fetchUserData();
  }, 300);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});
</script>
